module.exports = __webpack_public_path__ + "static/img/icon_game_10.eb671aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_10.png
// module id = CQFr
// module chunks = 0